import axios from '../lib/axios';
import { osName } from 'react-device-detect';
import { getDeviceType } from '../lib/utils';

export const RATE_VIEWER = 'RATE_VIEWER';
export const rateViewer = (navigationRate, executionRate, message) => {
    const url = `/api/rating`;
    const device = getDeviceType();

    axios
        .post(url, {
            navigationRate,
            executionRate,
            message,
            device,
            osName,
        })
        .catch(() => {});

    return {
        type: RATE_VIEWER,
    };
};
